import {
  UPDATE_PAGE,
  UPDATE_CONFIG,
  UPDATE_SETTINGS,
  UPDATE_ME,
  UPDATE_PATIENT,
  SHOW_OVERLAY, VERIFY_DISABLED
} from './types';

const INITIAL_STATE = {};

const showOverlay = (state, { show }) =>
  ({ ...state, showOverlay: show });

const updatePage = (state, { page, params, query }) => 
  ({ ...state, page, params, query });

const updateConfig = (state, { config }) =>
  ({ ...state, config });

const updateSettings = (state, { settings }) =>
  ({ ...state, settings, settingsLoaded: true });

const updateMe = (state, { me }) =>
  ({ ...state, me });

const updatePatient = (state, { patient }) =>
  ({ ...state, patient });

const verifyDisabled = (state, { disabled }) =>
  ({ ...state, verifyDisabled: disabled });

const reducers = {
  [UPDATE_PAGE]: updatePage,
  [UPDATE_CONFIG]: updateConfig,
  [UPDATE_SETTINGS]: updateSettings,
  [UPDATE_ME]: updateMe,
  [UPDATE_PATIENT]: updatePatient,
  [SHOW_OVERLAY]: showOverlay,
  [VERIFY_DISABLED]: verifyDisabled
};

const app = (state = INITIAL_STATE, action) =>
  (reducers[action.type] || (state => state))(state, action);

export default app;
